import { useState } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';

function ChangePassword(props) {
    const { socket, serial, setLoading } = props;

    const [password,] = useState(() => {
        const storedUser = atob(localStorage.getItem('access_key'));
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const [pass, setPass] = useState({
        password0: '',
        password1: '',
        password2: ''
    })

    const handleConfirm = async () => {
        const password0 = pass.password0;
        const password1 = pass.password1;
        const password2 = pass.password2;

        if (!password0 || !password1 || !password2) {
            alert("Preencha todos os campos!")
            return;
        }

        console.log(password);
        if (password !== password0) {
            alert("Senha atual incorreta!")
            return;
        }

        if (password1 === password2) {
            if (isPasswordSecure(password1)) {
                handleSetPassword(password1);
            } else {
                alert("A senha deve conter no minimo 4 caracteres!");
            }
        } else {
            alert("As senhas não são iguais");
        }
    }

    function isPasswordSecure(password) {
        if (password.length < 4) {
            return false;
        }
        return true;
    }

    const handleSetPassword = (password) => {
        if (!serial) {
            return
        }
        setLoading(true)
        socket.send(
            JSON.stringify({
                type: 'message',
                room: serial,
                content: {
                    command: 'web_browser',
                    parameters: {
                        value: 'set_change_password',
                        page: 'change_password',
                        password: password
                    }
                },
            })
        );
        localStorage.setItem('access_key', btoa(JSON.stringify(password)));
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleConfirm();
        }
    };


    return (
        <Card className="p-3" style={{ height: "96vh", background: "white" }}>
            <Form
                className='p-3 text-center'
                style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "30vh",
                    border: "solid 1px #198754",
                    borderRadius: "1rem"
                }}
            >
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword0">
                    <Col>
                        <Form.Control
                            value={pass.password0}
                            type="password"
                            placeholder="Senha Atual"
                            onKeyDown={handleKeyDown}

                            onChange={event => {
                                setPass({ ...pass, password0: event.target.value });
                            }}
                        />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword1">
                    <Col>
                        <Form.Control
                            value={pass.password1}
                            type="password"
                            placeholder="Nova Senha"
                            onKeyDown={handleKeyDown}
                            onChange={event => {
                                setPass({ ...pass, password1: event.target.value });
                            }}
                        />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword2">
                    <Col>
                        <Form.Control
                            value={pass.password2}
                            type="password"
                            placeholder="Confirmar Senha"
                            onKeyDown={handleKeyDown}
                            onChange={event => {
                                setPass({ ...pass, password2: event.target.value });
                            }}
                        />
                    </Col>
                </Form.Group>

                <Button
                    className='w-100'
                    variant="success"
                    onClick={() => {
                        handleConfirm()
                    }}>
                    Salvar
                </Button>

            </Form>
        </Card>
    );
}

export default ChangePassword;
